export const COLORS = {
  defaultDarkMode: '#1F2937',
  secondaryDarkMode: '#0D0E10',
  defaultLightMode: '#E3F2FD',
  secondaryLightMode: '#FFFFFF',
  headerLightMode: '#64b5f6',
  darkModeColor: '#FFFFFF',
  lightModeColor: '#000000',
};
